angular.module('LeasePilot').service('ReportsUiService', [
  '$http',
  function ReportsUiService($http) {
    function csrfToken() {
      var m = document.querySelector('meta[name="csrf-token"]');
      return m ? m.getAttribute('content') : '';
    }

    function request(config) {
      config.headers = config.headers || {};
      config.headers['X-CSRF-Token'] = csrfToken();
      config.headers['Accept'] = config.headers['Accept'] || 'application/json';
      return $http(config);
    }

    this.fetchSavedReports = function fetchSavedReports() {
      return request({
        method: 'GET',
        url: '/api/saved_reports'
      });
    };

    this.fetchSavedReport = function fetchSavedReport(id) {
      return request({
        method: 'GET',
        url: '/api/saved_reports/' + id
      });
    };

    this.createSavedReport = function createSavedReport(payload) {
      return request({
        method: 'POST',
        url: '/api/saved_reports',
        data: payload,
        headers: { 'Content-Type': 'application/json' }
      });
    };

    this.renameSavedReport = function renameSavedReport(id, name) {
      return request({
        method: 'PATCH',
        url: '/api/saved_reports/' + id,
        data: { name: name },
        headers: { 'Content-Type': 'application/json' }
      });
    };

    this.updateSavedReport = function updateSavedReport(id, payload) {
      return request({
        method: 'PATCH',
        url: '/api/saved_reports/' + id,
        data: payload,
        headers: { 'Content-Type': 'application/json' }
      });
    };

    this.deleteSavedReport = function deleteSavedReport(id) {
      return request({
        method: 'DELETE',
        url: '/api/saved_reports/' + id
      });
    };

    this.duplicateSavedReport = function duplicateSavedReport(id, name) {
      var data = {};
      if (name && String(name).trim()) data.name = String(name).trim();
      return request({
        method: 'POST',
        url: '/api/saved_reports/' + id + '/duplicate',
        data: data,
        headers: { 'Content-Type': 'application/json' }
      });
    };

    this.parseQuery = function parseQuery(query, mentions) {
      return request({
        method: 'POST',
        url: '/api/reports/parse_query',
        data: { query: query, mentions: mentions || [] },
        headers: { 'Content-Type': 'application/json' }
      });
    };

    this.fetchMentions = function fetchMentions(query, options) {
      var qs = '?q=' + encodeURIComponent(query || '');
      if (options && options.fieldLimit) {
        qs += '&field_limit=' + encodeURIComponent(options.fieldLimit);
      }
      if (options && options.buildingLimit) {
        qs += '&building_limit=' + encodeURIComponent(options.buildingLimit);
      }
      if (options && options.userLimit) {
        qs += '&user_limit=' + encodeURIComponent(options.userLimit);
      }
      return request({
        method: 'GET',
        url: '/api/reports/mentions' + qs
      });
    };

    this.generateReport = function generateReport(payload) {
      return request({
        method: 'POST',
        url: '/api/reports/generate',
        data: payload,
        headers: { 'Content-Type': 'application/json' }
      });
    };

    this.exportReport = function exportReport(payload, format) {
      var acceptType = format === 'xlsx' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv';
      return request({
        method: 'POST',
        url: '/api/reports/export',
        data: payload,
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          'Accept': acceptType
        }
      });
    };
  }
]);
